// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("../../assets/font/Inter-VariableFont.ttf", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `@font-face {
  font-family: "Inter";
  src: local("Inter"), url(${___CSS_LOADER_URL_REPLACEMENT_0___}) format("truetype");
}
.common-dialog-container .MuiDialog-paper {
  border-radius: 20px;
  position: relative;
  background-color: transparent;
  box-shadow: none;
  overflow: hidden;
  width: 100vw;
  height: 100vh;
  max-width: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  margin: 0;
}
@media screen and (min-width: 280px), screen and (max-width: 501px) {
  .common-dialog-container .MuiDialog-paper {
    min-width: 320px;
  }
}
.common-dialog-container .MuiDialog-paper form {
  position: relative;
  background-color: white;
  border-radius: 20px;
  padding: 30px 55px 45px;
  box-shadow: 0px 11px 15px -7px rgba(0, 0, 0, 0.2), 0px 24px 38px 3px rgba(0, 0, 0, 0.14), 0px 9px 46px 8px rgba(0, 0, 0, 0.12);
}
.common-dialog-container .MuiDialog-paper form.congratulation-dialog {
  padding: 30px 20px 45px;
  position: relative;
  z-index: 3;
}
.common-dialog-container .MuiDialog-paper .form {
  background-color: transparent;
}
.common-dialog-container .MuiDialog-paper .close-dialog-icon-button {
  width: 40px;
  height: 40px;
  border-radius: 5px;
  position: absolute;
  top: -30px;
  right: -30px;
}
@media screen and (min-width: 280px), screen and (max-width: 501) {
  .common-dialog-container .MuiDialog-paper .close-dialog-icon-button {
    width: 30px;
    height: 30px;
  }
  .common-dialog-container .MuiDialog-paper .close-dialog-icon-button .close-dialog-icon {
    width: 25px;
    height: 25px;
  }
}
.common-dialog-container .MuiDialog-paper .close-dialog-icon-button .close-dialog-icon {
  fill: #EE3A24;
  width: 35px;
  height: 35px;
}
.common-dialog-container .MuiDialog-paper .success-dialog .dialog-title {
  line-height: 24px;
  max-width: 80%;
  margin: 0 auto;
}
.common-dialog-container .MuiDialog-paper .success-dialog .dialog-subTitle {
  margin-top: 28px;
  margin-bottom: 40px;
  max-width: 90%;
  margin-left: auto;
  margin-right: auto;
}
.common-dialog-container .MuiDialog-paper .dialog-title {
  color: #EE3A24;
  font-family: Inter;
  font-size: 24px;
  font-weight: 800;
  line-height: 41px;
  letter-spacing: 0.04em;
  text-align: center;
}
.common-dialog-container .MuiDialog-paper .dialog-title.email-title {
  line-height: 25px;
}
.common-dialog-container .MuiDialog-paper .dialog-subTitle {
  color: #000000;
  font-family: Inter;
  font-size: 16px;
  font-weight: 500;
  line-height: 24px;
  letter-spacing: 0.04em;
  text-align: center;
}
.common-dialog-container .MuiDialog-paper .dialog-subTitle.congratulation-subTitle {
  margin-bottom: 21px;
}
.common-dialog-container .MuiDialog-paper .dialog-input-container {
  margin-top: 30px;
  margin-bottom: 30px;
}
.common-dialog-container .MuiDialog-paper .dialog-input-container.email-input-container {
  margin-top: 7px;
  margin-bottom: 15px;
}
.common-dialog-container .MuiDialog-paper .common-input-field {
  width: 100%;
}
.common-dialog-container .MuiDialog-paper .common-input-field .MuiInputBase-root {
  border-radius: 8px;
}
.common-dialog-container .MuiDialog-paper .common-input-field fieldset {
  border: 1px solid #CECECE;
}
.common-dialog-container .MuiDialog-paper .common-input-field input {
  padding: 14px;
  font-family: Inter;
  font-size: 16px;
  font-weight: 400;
  line-height: 19px;
  letter-spacing: 0em;
  text-align: left;
  color: #000000;
}
.common-dialog-container .MuiDialog-paper .common-input-field label {
  font-family: Inter;
  font-size: 16px;
  font-weight: 400;
  line-height: 19px;
  letter-spacing: 0em;
  text-align: left;
  color: #000000;
}
.common-dialog-container .MuiDialog-paper .dialog-submit-container {
  text-align: center;
}
.common-dialog-container .MuiDialog-paper .dialog-submit-container.congratulation-sumit-container {
  display: flex;
  justify-content: space-around;
}
.common-dialog-container .MuiDialog-paper .dialog-recaptcha {
  display: flex;
  justify-content: center;
  margin-bottom: 40px;
}
.common-dialog-container .MuiDialog-paper .dialog-input-submit {
  border-radius: 8px;
  border: 1px solid #EE3A24;
  outline: none;
  background-color: #fff;
  cursor: pointer;
  font-family: Inter;
  font-size: 20px;
  font-weight: 600;
  line-height: 24px;
  letter-spacing: 0em;
  text-align: center;
  color: #EE3A24;
  padding: 14px 70px;
  transition: all 0.4s;
}
.common-dialog-container .MuiDialog-paper .dialog-input-submit:hover, .common-dialog-container .MuiDialog-paper .dialog-input-submit:focus {
  background-color: rgba(238, 58, 36, 0.8);
  color: #fff;
}
.common-dialog-container .MuiDialog-paper .button-redirection-text {
  font-family: Inter;
  font-size: 10px;
  font-weight: 500;
  line-height: 12px;
  letter-spacing: 0em;
  text-align: center;
  margin-top: 4px;
  color: #000000;
}
.common-dialog-container .MuiModal-backdrop {
  background-color: rgba(0, 0, 0, 0.8) !important;
}`, "",{"version":3,"sources":["webpack://./src/style/_fonts.scss","webpack://./src/style/components/Dialog.scss"],"names":[],"mappings":"AAAA;EACI,oBAAA;EACA,+EAAA;ACCJ;AAAI;EACI,mBAAA;EACA,kBAAA;EACA,6BAAA;EACA,gBAAA;EACA,gBAAA;EACA,YAAA;EACA,aAAA;EACA,eAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,SAAA;AAER;AADQ;EAbJ;IAeQ,gBAAA;EAGV;AACF;AAFQ;EACI,kBAAA;EACA,uBAAA;EACA,mBAAA;EACA,uBAAA;EAEA,8HAAA;AAGZ;AADQ;EACI,uBAAA;EACA,kBAAA;EACA,UAAA;AAGZ;AADQ;EACI,6BAAA;AAGZ;AADQ;EACI,WAAA;EACA,YAAA;EACA,kBAAA;EACA,kBAAA;EACA,UAAA;EACA,YAAA;AAGZ;AADY;EARJ;IAUQ,WAAA;IACA,YAAA;EAGd;EADc;IACI,WAAA;IACA,YAAA;EAGlB;AACF;AAAY;EACI,aAAA;EACA,WAAA;EACA,YAAA;AAEhB;AAGY;EACI,iBAAA;EACA,cAAA;EACA,cAAA;AADhB;AAIY;EACI,gBAAA;EACA,mBAAA;EACA,cAAA;EACA,iBAAA;EACA,kBAAA;AAFhB;AAMQ;EACI,cAAA;EACA,kBAAA;EACA,eAAA;EACA,gBAAA;EACA,iBAAA;EACA,sBAAA;EACA,kBAAA;AAJZ;AAKY;EACI,iBAAA;AAHhB;AAOQ;EACI,cAAA;EACA,kBAAA;EACA,eAAA;EACA,gBAAA;EACA,iBAAA;EACA,sBAAA;EACA,kBAAA;AALZ;AAMY;EACI,mBAAA;AAJhB;AAQQ;EACI,gBAAA;EACA,mBAAA;AANZ;AAOY;EACI,eAAA;EACA,mBAAA;AALhB;AASQ;EACI,WAAA;AAPZ;AASY;EACI,kBAAA;AAPhB;AAUY;EACI,yBAAA;AARhB;AAWY;EACI,aAAA;EACA,kBAAA;EACA,eAAA;EACA,gBAAA;EACA,iBAAA;EACA,mBAAA;EACA,gBAAA;EACA,cAAA;AAThB;AAYY;EACI,kBAAA;EACA,eAAA;EACA,gBAAA;EACA,iBAAA;EACA,mBAAA;EACA,gBAAA;EACA,cAAA;AAVhB;AAcQ;EACI,kBAAA;AAZZ;AAaY;EACI,aAAA;EACA,6BAAA;AAXhB;AAeQ;EACI,aAAA;EACA,uBAAA;EACA,mBAAA;AAbZ;AAgBQ;EACI,kBAAA;EACA,yBAAA;EACA,aAAA;EACA,sBAAA;EACA,eAAA;EACA,kBAAA;EACA,eAAA;EACA,gBAAA;EACA,iBAAA;EACA,mBAAA;EACA,kBAAA;EACA,cAAA;EACA,kBAAA;EACA,oBAAA;AAdZ;AAgBY;EAEI,wCAAA;EACA,WAAA;AAfhB;AAmBQ;EACI,kBAAA;EACA,eAAA;EACA,gBAAA;EACA,iBAAA;EACA,mBAAA;EACA,kBAAA;EACA,eAAA;EACA,cAAA;AAjBZ;AAoBI;EACI,+CAAA;AAlBR","sourcesContent":["@font-face {\n    font-family: \"Inter\";\n    src: local(\"Inter\"),\n     url(\"../assets/font/Inter-VariableFont.ttf\") format(\"truetype\");\n   }\n@mixin primeFont() {\n    font-family: \"Inter\";\n}","@import '../mixins';\n\n.common-dialog-container {\n    .MuiDialog-paper {\n        border-radius: 20px;\n        position: relative;\n        background-color: transparent;\n        box-shadow: none;\n        overflow: hidden;\n        width: 100vw;\n        height: 100vh;\n        max-width: 100%;\n        display: flex;\n        align-items: center;\n        justify-content: center;\n        margin: 0;\n        @media screen and (min-width:280px),\n        screen and (max-width:501px) {\n            min-width: 320px;\n        }\n        form{\n            position: relative;\n            background-color: white;\n            border-radius: 20px;\n            padding: 30px 55px 45px;\n            // max-width: 400px;\n            box-shadow: 0px 11px 15px -7px rgba(0,0,0,0.2), 0px 24px 38px 3px rgba(0,0,0,0.14), 0px 9px 46px 8px rgba(0,0,0,0.12);\n        }\n        form.congratulation-dialog{\n            padding: 30px 20px 45px;            \n            position: relative;\n            z-index: 3;\n        }\n        .form{\n            background-color: transparent;\n        }\n        .close-dialog-icon-button {\n            width: 40px;\n            height: 40px;\n            border-radius: 5px;\n            position: absolute;\n            top: -30px;\n            right: -30px;\n\n            @media screen and (min-width:280px),\n            screen and (max-width:501) {\n                width: 30px;\n                height: 30px;\n\n                .close-dialog-icon {\n                    width: 25px;\n                    height: 25px;\n                }\n            }\n\n            .close-dialog-icon {\n                fill: #EE3A24;\n                width: 35px;\n                height: 35px;\n            }\n        }\n\n        .success-dialog {\n            .dialog-title {\n                line-height: 24px;\n                max-width: 80%;\n                margin: 0 auto;\n            }\n\n            .dialog-subTitle {\n                margin-top: 28px;\n                margin-bottom: 40px;\n                max-width: 90%;\n                margin-left: auto;\n                margin-right: auto;\n            }\n        }\n\n        .dialog-title {\n            color: #EE3A24;\n            font-family: Inter;\n            font-size: 24px;\n            font-weight: 800;\n            line-height: 41px;\n            letter-spacing: 0.04em;\n            text-align: center;\n            &.email-title{\n                line-height: 25px;\n            }\n        }\n\n        .dialog-subTitle {\n            color: #000000;\n            font-family: Inter;\n            font-size: 16px;\n            font-weight: 500;\n            line-height: 24px;\n            letter-spacing: 0.04em;\n            text-align: center;\n            &.congratulation-subTitle{\n                margin-bottom: 21px;\n            }\n        }\n\n        .dialog-input-container {\n            margin-top: 30px;\n            margin-bottom: 30px;\n            &.email-input-container{\n                margin-top: 7px;\n                margin-bottom: 15px;\n            }\n        }\n\n        .common-input-field {\n            width: 100%;\n\n            .MuiInputBase-root {\n                border-radius: 8px;\n            }\n\n            fieldset {\n                border: 1px solid #CECECE;\n            }\n\n            input {\n                padding: 14px;\n                font-family: Inter;\n                font-size: 16px;\n                font-weight: 400;\n                line-height: 19px;\n                letter-spacing: 0em;\n                text-align: left;\n                color: #000000;\n            }\n\n            label {\n                font-family: Inter;\n                font-size: 16px;\n                font-weight: 400;\n                line-height: 19px;\n                letter-spacing: 0em;\n                text-align: left;\n                color: #000000;\n            }\n        }\n\n        .dialog-submit-container {\n            text-align: center;\n            &.congratulation-sumit-container{\n                display: flex;\n                justify-content: space-around;\n            }\n        }\n\n        .dialog-recaptcha {\n            display: flex;\n            justify-content: center;\n            margin-bottom: 40px;\n        }\n\n        .dialog-input-submit {\n            border-radius: 8px;\n            border: 1px solid #EE3A24;\n            outline: none;\n            background-color: #fff;\n            cursor: pointer;\n            font-family: Inter;\n            font-size: 20px;\n            font-weight: 600;\n            line-height: 24px;\n            letter-spacing: 0em;\n            text-align: center;\n            color: #EE3A24;\n            padding: 14px 70px;\n            transition: all 0.4s;\n\n            &:hover,\n            &:focus {\n                background-color: #EE3A24CC;\n                color: #fff;\n            }\n        }\n\n        .button-redirection-text {\n            font-family: Inter;\n            font-size: 10px;\n            font-weight: 500;\n            line-height: 12px;\n            letter-spacing: 0em;\n            text-align: center;\n            margin-top: 4px;\n            color: #000000;\n        }\n    }\n    .MuiModal-backdrop{\n        background-color: #000000CC !important;\n    } \n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
